<template>
    <b-nav-item-dropdown
        v-if="_hasAccess('schedule.access')"
        data-top-right-id="tasks"
        no-caret
        right
    >
        <template slot="button-content">
            <i id="tasks_bell_top" class="fas fa-tasks"></i>
            <span class="d-lg-none">Task</span>
            <div v-if="isNotificationEnabled && badgeCount > 0" class="badge">
                {{ badgeCount > 99 ? "99+" : badgeCount }}
            </div>
        </template>
        <b-dropdown-item
            data-top-tasks-id="assigned-to-me"
            to="/schedule/tasks?status=3"
        >
            <i class="fas fa-tasks child"></i>
            {{ incompleteLabel }}
        </b-dropdown-item>
        <b-dropdown-item
            data-top-tasks-id="created-by-me"
            to="/schedule/tasks?status=4"
        >
            <i class="fas fa-tasks child"></i>
            Created by Me
        </b-dropdown-item>
        <b-dropdown-item
            v-if="_hasAccess('schedule.task.access')"
            data-top-tasks-id="open-in-progress"
            to="/schedule/tasks?task_status=0"
        >
            <i class="fas fa-tasks child"></i>
            All Open & In Progress
        </b-dropdown-item>
        <b-dropdown-item
            v-if="_hasAccess('schedule.task.access')"
            data-top-tasks-id="completed"
            to="/schedule/tasks?task_status=1"
        >
            <i class="fas fa-tasks child"></i>
            All Completed
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item
            data-top-tasks-id="new-task"
            @click.stop="showNewTaskModal()"
        >
            <i class="fas fa-plus-circle child" style="color: #678f35;"></i>
            New Task
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
export default {
    props: {
        showNewTaskModal: {
            type: Function
        },
        isNotificationEnabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        badgeCount() {
            return this.$store.getters["task/badgeCount"];
        },
        incompleteLabel() {
            let str = "Assigned to Me";

            if (this.isNotificationEnabled && this.badgeCount > 0) {
                let countStr = this.badgeCount > 99 ? "99+" : this.badgeCount;
                str += ` (${countStr})`;
            }

            return str;
        }
    }
};
</script>

<style lang="scss" scoped>
.badge {
    transition: none;
    background: red;
    position: absolute;
    top: -3px;
    right: 0;
    font-size: 0.7em;
}
.fas.child {
    margin-right: 5px;
}
</style>
